import { apiUtils } from '../utils/apiUtils'
import downloadjs from 'downloadjs'
import moment from 'moment'
export default {
  get: function (clientid) {
    return fetch(apiUtils.integrationEnroll + '/pms/?clientId=' + clientid, {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) {
        return res.json()
      } else if (res.status === 404) {
        return { error: 'Aucun fichier pms trouvé' }
      }
      return Promise.resolve({})
    })
  },
  getByEnrollId: function (enrollid) {
    return fetch(apiUtils.integrationEnroll + '/pms/' + enrollid, {
      method: 'GET',
    }).then((res) => {
      if (res.status === 200) return res.json()
      return []
    }).catch(() => [])
  },
  upsert: function (code, plateau) {
    return fetch(apiUtils.integrationEnroll + '/pms/' + code, {
      method: 'POST',
      body: JSON.stringify(plateau)
    })
  },
  download (filename) {
    const file = filename.file || filename.nom
    return fetch(apiUtils.integrationEnroll + '/pms/download/' + file, {
      method: 'GET'
    })
      .then((response) => response.blob())
      .then((blob) => {
        downloadjs(blob, filename.nom)
      })
  },
  upload: function (file, model, clientid, code, nom, ext) {
    console.log('Sending file with : ', 'nom '+nom, '- code '+code, ' ext - '+ext)
    const data = new FormData()
    data.append('file', file.file)
    data.append('nom', nom)
    data.append('ext', ext)
    data.append('date', moment().format('YYYY-MM-DD HH:mm:ss'))
    if (clientid !== undefined && clientid !== null && clientid !== '') data.append('clientid', clientid)
    return fetch(apiUtils.integrationEnroll + '/file/pms/' + code, {
      method: 'POST',
      body: data
    }).then((res) => {
      if (res.status === 200 || res.status === 201) {
        return res.json().then(row => ({ ...row, nom: file.nom }))
      }
      return Promise.reject(new Error(`ERR_${res.status} - Erreur pendant l'envoi du fichier`))
    }).catch(err => Promise.reject(err instanceof Error ? err : new Error('ERR_Erreur pendant l\'envoi du fichier')))
  },
  remove: function (file, model, code) {
    return fetch(apiUtils.integrationEnroll + '/pms/' + code, {
      method: 'DELETE',
      body: JSON.stringify(file.nom)
    })
  }
}
